import { AnimatePresence} from "framer-motion";
import { Routes, Route, useLocation } from "react-router-dom"

import Error404 from "containers/errors/Error404";
import Home from "containers/pages/Home";
import Login from "containers/pages/Login";
import Eventos from "containers/pages/Eventos";
import Register from "containers/pages/Register";
import ForgotPass from "containers/pages/ForgotPass";
import ResetPass from "containers/pages/ResetPass";
import Activate from "containers/pages/Activate";
import EventoTrips from "containers/pages/EventoTrips";
import Trip from "containers/pages/Trip";
import Profile from "containers/pages/Profile";
import MyProfile from "containers/pages/MyProfile";
import MisTrips from "containers/pages/MisTrips";
import NewTrips from "containers/pages/NewTrips";

function AnimatedRoutes(){

    const location = useLocation()

    return(
        <AnimatePresence>
            <Routes location={location} key={location.pathname}>
                <Route path="*" element={<Error404 />} />
                <Route path="/" element={<Home />} />
                <Route path="/eventos" element={<Eventos />} />
                <Route path="/eventos/:slug" element={<EventoTrips />} />
                <Route path="/trip/:slug" element={<Trip />} />
                <Route path="/trips" element={<MisTrips/>} />
                <Route path="/profile/me" element={<MyProfile />} />
                <Route path="/new_trip" element={<NewTrips/>} />

                

                <Route path="/login" element={<Login/>} />
                <Route path="/register" element={<Register/>} />
                <Route path="/forgot_password" element={<ForgotPass/>} />
                <Route path="/password/reset/confirm/:uid/:token" element={<ResetPass/>} />
                <Route path="/activate/:uid/:token" element={<Activate/>} />
                
                {/* <Route path="/profile/:slug" element={<Profile />} /> */}

            </Routes>
        </AnimatePresence>
    )
}

export default AnimatedRoutes